import _fromPairs from 'lodash/fromPairs';

const requireContext = require.context('./', true, /^\.\/([^/]+)\/([^/]+)\/index\.(js|coffee)$/);

const pages = _fromPairs(
    requireContext.keys().map((pagePath) => {
        const module = pagePath.replace(/^\.\/([^/]+)\/([^/]+)\/index\.(js|coffee)$/, '$1/$2');
        return [module, pagePath];
    })
);

export const requirePage = function (page) {
    return requireContext(pages[page]);
};

export default Object.keys(pages);



// WEBPACK FOOTER //
// ./src/views/themes/front/pages/index.js